import { z } from "zod";
import { SurveyQuestionSchema } from "../survey/survey.schema";

export const SurveyResponseQuestionSchema = z
  .object({
    surveyResponseId: z.string().min(1),
    surveyQuestionId: z.string().min(1),
    response: z.string().nullable(),
    surveyQuestion: SurveyQuestionSchema.optional(),
    createdTs: z.string().transform((str) => new Date(str)),
    updatedTs: z
      .string()
      .nullable()
      .optional()
      .transform((str) => (str ? new Date(str) : null)),
  })
  .strict();

export const SurveyResponseSchema = z
  .object({
    id: z.string().min(1),
    surveyId: z.string().min(1),
    userId: z.string().nullable().optional(),
    yzAnonymousId: z.string().nullable().optional(),
    buildProjectId: z.string().nullable().optional(),
    completed: z.boolean().nullable().optional(),
    nextQuestionId: z.string().nullable().optional(),
    createdTs: z.string().transform((str) => new Date(str)),
    updatedTs: z
      .string()
      .nullable()
      .optional()
      .transform((str) => (str ? new Date(str) : null)),
    surveyQuestionResponses: z.array(SurveyResponseQuestionSchema),
  })
  .strict();

export class InvalidSurveyResponseResponseError extends Error {
  constructor(public errors: z.ZodError) {
    super("Invalid SurveyResponse response");
    this.name = "InvalidSurveyResponseResponseError";
  }
}

export class EmptySurveyResponseResponseError extends Error {
  constructor() {
    super("Empty SurveyResponse response");
    this.name = "EmptySurveyResponseResponseError";
  }
}
